import { ParameterTagsProps } from "./types";

import TagInput from "@/components/ui/TagInput";

export const ParameterTags = ({
  onChange,
  value,
  defaultValue,
  isDisabled,
  placeholder,
  readOnly,
  isPreview,
}: ParameterTagsProps) => {
  const inputValue =
    typeof value === "string"
      ? value.split(",")
      : value ||
        (typeof defaultValue === "string" ? (defaultValue as string).split(",") : defaultValue) ||
        [];

  return (
    <TagInput
      placeholder={placeholder}
      initialTags={inputValue}
      disabled={isDisabled || isPreview || readOnly}
      shouldNormalizeTags
      className="!min-w-[50px] bg-transparent"
      onTagsChange={onChange}
    />
  );
};
